export default {
  arrrowLinkFill: Styles.color.black,
  arrowLinkLabelColor: Styles.color.black,
};
